import { render } from "./ChartjsApp.vue?vue&type=template&id=080bfcbe"
import script from "./ChartjsApp.vue?vue&type=script&lang=js"
export * from "./ChartjsApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/ChartjsApp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "080bfcbe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('080bfcbe', __exports__)) {
    api.reload('080bfcbe', __exports__)
  }
  
  module.hot.accept("./ChartjsApp.vue?vue&type=template&id=080bfcbe", () => {
    api.rerender('080bfcbe', render)
  })

}


export default __exports__